import { AxiosInstance } from "axios";
import ApiClient from "./ApiClient";
import {
  Question,
  QuestionCreate,
  QuestionUpdate,
  QuestionOrderUpdate,
} from "../types/ApplicationQuestion";

// Base URL for Mentoring Fusion API
const API_URL = process.env.REACT_APP_MENTORING_API_URL ?? "";

class ApplicationQuestionService {
  private apiClient: AxiosInstance;

  constructor() {
    this.apiClient = new ApiClient(API_URL).getClient();
  }

  /* -------------------------------------------------------------------------- */
  /*                               CRUD - Questions                             */
  /* -------------------------------------------------------------------------- */

  public listQuestions = async (
    organizationId: string,
    campaignId: string
  ): Promise<Question[]> => {
    const res = await this.apiClient.get<Question[]>(
      `/organizations/${organizationId}/campaigns/${campaignId}/questions`
    );
    return res.data;
  };

  public addQuestion = async (
    organizationId: string,
    campaignId: string,
    payload: QuestionCreate
  ): Promise<Question> => {
    const res = await this.apiClient.post<Question>(
      `/organizations/${organizationId}/campaigns/${campaignId}/questions`,
      payload
    );
    return res.data;
  };

  public getQuestion = async (
    organizationId: string,
    campaignId: string,
    questionId: string
  ): Promise<Question> => {
    const res = await this.apiClient.get<Question>(
      `/organizations/${organizationId}/campaigns/${campaignId}/questions/${questionId}`
    );
    return res.data;
  };

  public updateQuestion = async (
    organizationId: string,
    campaignId: string,
    questionId: string,
    updates: QuestionUpdate
  ): Promise<Question> => {
    const res = await this.apiClient.put<Question>(
      `/organizations/${organizationId}/campaigns/${campaignId}/questions/${questionId}`,
      updates
    );
    return res.data;
  };

  public deleteQuestion = async (
    organizationId: string,
    campaignId: string,
    questionId: string
  ): Promise<Question> => {
    const res = await this.apiClient.delete<Question>(
      `/organizations/${organizationId}/campaigns/${campaignId}/questions/${questionId}`
    );
    return res.data;
  };

  /* -------------------------------------------------------------------------- */
  /*                              Question Order                                */
  /* -------------------------------------------------------------------------- */

  public getQuestionOrder = async (
    organizationId: string,
    campaignId: string
  ): Promise<string[]> => {
    const res = await this.apiClient.get<string[]>(
      `/organizations/${organizationId}/campaigns/${campaignId}/questions/order`
    );
    return res.data;
  };

  public updateQuestionOrder = async (
    organizationId: string,
    campaignId: string,
    order: QuestionOrderUpdate
  ): Promise<string[]> => {
    const res = await this.apiClient.put<string[]>(
      `/organizations/${organizationId}/campaigns/${campaignId}/questions/order`,
      order
    );
    return res.data;
  };
}

export default ApplicationQuestionService;
